import React, { useCallback, useId } from "react";
import { formatISO } from "date-fns";
import { useFormik } from "formik";
import { useUser } from "@hooks/useUser";
import { useUpdateUserMutation } from "@api/user.api";
import { Switch } from "@design-system/Switch/Switch";
import styles from "./Notifications.module.scss";

interface Schema {
    dailyTasksDigestEnabledAt: string | null;
}

export const Notifications: React.FC = () => {
    const { settings } = useUser();
    const updateUser = useUpdateUserMutation();
    const dailyDigestLabelId = useId();

    const formik = useFormik<Schema>({
        initialValues: {
            dailyTasksDigestEnabledAt:
                settings.dailyTasksDigestEnabledAt ?? null,
        },
        onSubmit: async (values) => {
            await updateUser.mutateAsync({
                settings: {
                    ...settings,
                    dailyTasksDigestEnabledAt: values.dailyTasksDigestEnabledAt,
                },
            });
        },
    });

    const handleDailyDigestToggle = useCallback(() => {
        const newValue = formik.values.dailyTasksDigestEnabledAt
            ? null
            : formatISO(new Date());
        formik.setFieldValue("dailyTasksDigestEnabledAt", newValue);
        formik.submitForm();
    }, [formik]);

    return (
        <section className={styles.settings}>
            <form onSubmit={formik.handleSubmit}>
                <article className={styles.settingElement}>
                    <div>
                        <header id={dailyDigestLabelId}>
                            Daily tasks digest
                        </header>
                        <p>A summary of your daily tasks</p>
                    </div>

                    <Switch
                        checked={!!formik.values.dailyTasksDigestEnabledAt}
                        onCheckedChange={handleDailyDigestToggle}
                        aria-labelledby={dailyDigestLabelId}
                    />
                </article>
            </form>
        </section>
    );
};
